import { SVGProps, Ref, forwardRef } from 'react'
const SvgRibbonShield = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.4 15.3a9.112 9.112 0 0 0 3.973 3l.8.308a2.305 2.305 0 0 0 1.656 0l.8-.308a9.117 9.117 0 0 0 3.973-3M19.405 10.993A9.12 9.12 0 0 0 19.5 9.75V4.69a1.145 1.145 0 0 0-.667-1.047A16.713 16.713 0 0 0 12 2.25a16.713 16.713 0 0 0-6.833 1.393A1.145 1.145 0 0 0 4.5 4.69V9.75c.005.416.038.831.1 1.243M4.555 13.342S3.75 16.5.75 16.5L3 18 .75 21.75a8.11 8.11 0 0 0 6-2.986M19.445 13.342s.8 3.158 3.805 3.158L21 18l2.25 3.75a8.11 8.11 0 0 1-6-2.986"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 12.75a8.1 8.1 0 0 1 6 3L20.25 12S18 8.25 12 8.25 3.75 12 3.75 12L6 15.75a8.1 8.1 0 0 1 6-3v0Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgRibbonShield)
export default ForwardRef
